import React, { useState } from "react";

import Box from "components/common/Box";
import Text from "components/common/Text";
import Image from "components/common/Image";
import Modal from "components/common/Modal";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";

const MarketPulseDetailCard = ({
  title,
  duration = "",
  audioUrl = "",
  image,
  showAudio = true,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!image?.url) {
    return null;
  }

  return (
    <>
      <Box
        sx={{
          width: "100%",
          borderRadius: { xs: "14px", md: "16px" },
          backgroundColor: "#FFFFFF",
          border: "1px solid #E8ECF0",
          boxShadow: "0 1px 6px rgba(15, 23, 42, 0.04)",
          p: { xs: 2, sm: 2.5, md: 3 },
          mb: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            mb: 2,
          }}
        >
          <Text sx={{ fontWeight: 700, fontSize: { xs: "16px", sm: "18px" }, color: "#111827" }}>
            {title}
          </Text>
          {duration ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flexShrink: 0 }}>
              <AccessTimeOutlinedIcon sx={{ fontSize: 16, color: "#9CA3AF" }} />
              <Text sx={{ fontSize: "13px", color: "#6B7280", fontWeight: 500 }}>{duration}</Text>
            </Box>
          ) : null}
        </Box>

        {showAudio && audioUrl ? (
          <Box
            component="audio"
            controls
            src={audioUrl}
            sx={{
              width: "100%",
              height: 40,
              mb: 2,
              "&::-webkit-media-controls-panel": {
                backgroundColor: "#F9FAFB",
              },
            }}
          />
        ) : null}

        <Box
          onClick={() => setIsModalOpen(true)}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              setIsModalOpen(true);
            }
          }}
          sx={{
            width: "100%",
            borderRadius: "12px",
            overflow: "hidden",
            border: "1px solid #EEF0F2",
            cursor: "pointer",
            backgroundColor: "#FAFBFC",
            "&:hover": { opacity: 0.95 },
          }}
        >
          <Image
            src={image.url}
            alt={title}
            objectFit="contain"
            height="auto"
            rootStyle={{ width: "100%" }}
            imgStyle={{ width: "100%", display: "block" }}
          />
        </Box>
      </Box>

      <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)} title={title} size="lg">
        <Image
          src={image.url}
          alt={title}
          objectFit="contain"
          height="auto"
          rootStyle={{ width: "100%" }}
          imgStyle={{ maxHeight: "70vh", width: "100%" }}
        />
      </Modal>
    </>
  );
};

export default MarketPulseDetailCard;
